const formatterCache = new Map<string, Intl.NumberFormat>();

interface FormatCurrencyOptions extends Intl.NumberFormatOptions {
  locale?: string;
}

export const getLocaleFromTimezone = (timezone?: string): string => {
  if (!timezone) return 'fr-FR';
  const lower = timezone.toLowerCase();
  if (lower.includes('america') || lower.includes('us')) {
    return 'en-US';
  }
  if (lower.includes('british') || lower.includes('london') || lower.includes('uk')) {
    return 'en-GB';
  }
  return 'fr-FR';
};

export const formatCurrency = (
  value: number,
  currency: string = 'EUR',
  options: FormatCurrencyOptions = {}
): string => {
  const locale = options.locale || 'fr-FR';
  const minDigits =
    options.minimumFractionDigits ?? (Number.isInteger(value) ? 0 : 2);
  const maxDigits =
    options.maximumFractionDigits ?? (Number.isInteger(value) ? 0 : 2);

  const cacheKey = `${locale}-${currency}-${minDigits}-${maxDigits}`;

  let formatter = formatterCache.get(cacheKey);
  if (!formatter) {
    formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: minDigits,
      maximumFractionDigits: maxDigits,
    });
    formatterCache.set(cacheKey, formatter);
  }

  return formatter.format(value);
};
